import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { PATHS } from "util/appConstants";
import {
  selectCustomer,
  selectCustomerStatus,
  getCustomer,
  editCustomer,
} from "redux/slices/customerSlice";
import { getTours, selectTours } from "redux/slices/tourSlice";
import { getZipcodes, selectZipcodes, selectZipcodeStatus } from 'redux/slices/zipcodeSlice';
import CustomerForm from "components/Customers/form";
import Navbar from 'components/Navbar';
import LightLayout from 'components/Shared/LightLayout';
import CustomersNavbar from 'components/Masterbar/CustomersBar';

const currentAction = "EDIT";

const EditCustomer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const loading = useSelector(selectCustomerStatus);
  const loadingZipcodes = useSelector(selectZipcodeStatus);
  const zipcodes = useSelector(selectZipcodes);
  const customer = useSelector(selectCustomer);
  const tours = useSelector(selectTours);

  useEffect(() => {
    if (id && !loading) {
      dispatch(getCustomer(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (!tours.length) {
      dispatch(getTours());
    }
  }, [dispatch, tours]);

  useEffect(() => {
    if (!loadingZipcodes) {
      dispatch(getZipcodes());
    }
  }, []);

  const onSubmit = async (payload) => {
    await dispatch(editCustomer(id, payload));

    history.push(PATHS.customers.detail.replace(':id', id));
  };

  const customerWithMappings = useMemo(() => {
    if (!customer) return null;
    const tourMap = new Map();
    const timings = customer.CustomerDeliveryTimings || [];
    for (const cdt of timings) {
      const tdt = cdt.ToursDeliveryTiming;
      if (tdt) {
        const tid = Number(tdt.tour_id);
        if (!tourMap.has(tid)) {
          tourMap.set(tid, new Set());
        }
        if (tdt.delivery_timing) {
          tourMap.get(tid).add(tdt.delivery_timing);
        }
      }
    }
    const tourMappings = [...tourMap.entries()].map(([tid, deps]) => ({
      tour_id: tid,
      departures: [...deps],
    }));

    return {
      ...customer,
      tour_mappings: tourMappings.length
        ? tourMappings
        : customer.tour_id
        ? [{ tour_id: Number(customer.tour_id), departures: [] }]
        : [{ tour_id: null, departures: [] }],
    };
  }, [customer]);

  return (
    <>
      <Navbar />
      <CustomersNavbar />
      <LightLayout doublebar loading={loading || !customer}>
        <CustomerForm
          initialValues={customerWithMappings}
          onSubmit={onSubmit}
          action={currentAction}
          tourList={tours}
          zipcodes={zipcodes}
        />
      </LightLayout>
    </>
  );
};
export default EditCustomer;
